// refusal.ts — (B111; planning 10-24 18:50, audit N3) a refused answer's body → its code, message and details. Pure (the
// client calls it; a test reads it directly). Four shapes reach the app:
//   { error: { code, message, details } }   the backend's error handler
//   { error: "<reason>", code?, detail? }   the growth admin routes and the backend's own proxies (words, cast, …): a
//                                           string `error` IS the message, and its `code` beside it is the code (B111:
//                                           before, it was dropped, so every such refusal read code UNKNOWN)
//   { ok: false, reason, code? }            the engine's ops routes (session 10, A7)
//   anything else                           UNKNOWN, "Request failed with status N"
export interface Refusal { code: string; message: string; details?: unknown; requestId?: string }

export function refusalOf(status: number, body: unknown): Refusal {
  const out: Refusal = { code: "UNKNOWN", message: `Request failed with status ${status}` };
  if (!body || typeof body !== "object") return out;
  const b = body as { error?: unknown; detail?: unknown; reason?: unknown; code?: unknown; requestId?: unknown };
  if (typeof b.error === "string") {
    out.message = b.error;
    out.details = b.detail;
    if (typeof b.code === "string" && b.code) out.code = b.code;
  } else if (b.error === undefined && typeof b.reason === "string") {
    out.message = b.reason;
    if (typeof b.code === "string" && b.code) out.code = b.code;
  } else if (b.error && typeof b.error === "object") {
    const e = b.error as { code?: unknown; message?: unknown; details?: unknown };
    if (typeof e.code === "string") out.code = e.code;
    if (typeof e.message === "string") out.message = e.message;
    out.details = e.details;
  }
  if (typeof b.requestId === "string") out.requestId = b.requestId;
  return out;
}
